<template>
  <div class="is-flex">
    <div class="is-full-width" :title="eligibleTitle"
      v-if="percent >= upperBound">
      <div class="match-block-eligible"
        :class="{'small' : this.size === 'small', 'medium' : this.size === 'medium'}">
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" />
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" />
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-success" />
      </div>
    </div>
    <div class="is-full-width" :title="nearEligibleTitle"
      v-if="percent < upperBound && percent >= lowerBound">
      <div class="match-block-near-eligible"
        :class="{'small' : this.size === 'small','medium' : this.size === 'medium'}">
        <font-awesome-icon :icon="['fas','square-full']" />
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-warning" />
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-warning" />
      </div>
    </div>
    <div class="is-full-width" :title="notEligibleTitle"
      v-if="percent < lowerBound && percent > -1">
      <div class="match-block-not-eligible"
        :class="{'small' : this.size === 'small','medium' : this.size === 'medium'}">
        <font-awesome-icon :icon="['fas','square-full']" />
        <font-awesome-icon :icon="['fas','square-full']" />
        <font-awesome-icon :icon="['fas','square-full']" class="has-text-danger"/>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-solid-svg-icons';
import { mapGetters } from 'vuex';

library.add(faSquareFull);

export default {
  props: {
    value: {
      type: Number,
    },
    fieldTitle: {
      type: String,
      default: 'ISP',
    },
    title: {
      type: String,
      default: 'Eligible',
    },
    isPercent: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    percent() {
      return this.isPercent ? this.value : parseFloat((this.value * 100).toFixed(2));
    },
    upperBound() {
      if (!this.properties['CEP-ISP_PERCENT']) {
        return 25;
      }
      return this.properties['CEP-ISP_PERCENT'] * 100;
    },
    lowerBound() {
      if (!this.properties['CEP-GRACE_YEAR_PERCENT']) {
        return 15;
      }
      return this.properties['CEP-GRACE_YEAR_PERCENT'] * 100;
    },
    eligibleTitle() {
      return `${this.title} (${this.fieldTitle} >= ${this.upperBound} %)`;
    },
    nearEligibleTitle() {
      return `Near ${this.title} (${this.lowerBound} % =< ${this.fieldTitle} < ${this.upperBound} %)`;
    },
    notEligibleTitle() {
      return `Not ${this.title} (${this.fieldTitle} < ${this.lowerBound} %)`;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .match-block-eligible
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    color: #28a745
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom: none
  .match-block-near-eligible
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    color: #eee
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom:none
  .is-warning
    color: #ffc107
  .match-block-not-eligible
    display: flex
    flex-direction: column
    justify-content: center
    height: 100%
    color: #eee
    & > *
      margin-bottom: .25rem
    &:last-child
      margin-bottom: none
  .small
    font-size: 0.5em
  .medium
    font-size: 0.6em
</style>
